

<template>
  <div class="product-container">
    <!-- 汇总 -->
    <div style="margin: 10px 0">
      截至目前：总播放量 {{ allCount.totalWatchCount }}次，总分享量{{
        allCount.totalShareCount
      }}次，总消费次数{{ allCount.totalConsumptionCount }}次，总消费金额{{
        allCount.totalConsumptionAmount
      }}元
    </div>
    <!-- tab切换栏 -->
    <div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="播放统计" name="first"></el-tab-pane>
        <el-tab-pane label="播放明细" name="second"></el-tab-pane>
        <el-tab-pane label="分享明细" name="third"></el-tab-pane>
        <el-tab-pane label="消费明细" name="fourth"></el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="activeName == 'first'">
      <!-- 顶部搜索区域 -->
      <div class="search-box">
        <el-form :inline="true">
          <el-form-item>
            <el-input
              v-model="searchForm.productCodeOrTitle"
              placeholder="产品编号/产品标题"
              clearable
              class="search-input"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.status"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <toolbar
              :buttonList="buttonList"
              @callFunction="callFunction"
            ></toolbar>
          </el-form-item>
        </el-form>
      </div>
      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%; margin-top: 16px"
        class="custom-padding-table"
       
      >
        <el-table-column
          prop="code"
          label="产品ID"
          align="center"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="headline"
          label="产品标题"
          align="center"
          min-width="260"
        ></el-table-column>
        <el-table-column
          prop="clickCount"
          label="播放量"
          align="center"
          min-width="120"
        >
        <template #default="scope">
          <span style="color:red;cursor:pointer;" @click="jumpDetail(scope.row,1)">{{scope.row.clickCount}}</span>
        </template></el-table-column>
        <el-table-column
          prop="shareCount"
          label="分享量"
          align="center"
          min-width="120"
        ><template #default="scope">
          <span style="color:red;cursor:pointer;" @click="jumpDetail(scope.row,2)">{{scope.row.shareCount}}</span>
        </template>
        </el-table-column>
        <el-table-column
          prop="consumptionCount"
          label="消费次数"
          align="center"
          min-width="120"
        >
        <template #default="scope">
          <span style="color:red;cursor:pointer;" @click="jumpDetail(scope.row,3)">{{scope.row.consumptionCount}}</span>
        </template>
        </el-table-column>
        <el-table-column
          prop="consumptionAmount"
          label="消费金额"
          align="center"
          min-width="120"
        >
        <template #default="scope">
          <span style="color:red;cursor:pointer;" @click="jumpDetail(scope.row,4)">{{scope.row.consumptionAmount}}</span>
        </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageInfo.currentPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <div v-if="activeName == 'second'">
      <!-- 顶部搜索区域 -->
      <div class="search-box">
        <el-form :inline="true">
          <el-form-item>
            <span>时间:</span>
            <el-date-picker
              v-model="searchForm2.dateRange"
              type="daterange"
              range-separator="-"
              separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              style="width: 280px"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryClick2">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 数据表格 -->
      <el-table
        :data="tableData2"
        border
        stripe
        style="width: 100%; margin-top: 16px"
        class="custom-padding-table"
      >
        <el-table-column
          prop="code"
          label="产品ID"
          align="center"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="headline"
          label="产品标题"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="nickName"
          label="用户名(昵称)"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="播放时间"
          align="center"
          min-width="120"
        ></el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="pageInfo2.currentPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageInfo2.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total2"
        >
        </el-pagination>
      </div>
    </div>

    <div v-if="activeName == 'third'">
      <!-- 顶部搜索区域 -->
      <div class="search-box">
        <el-form :inline="true">
          <el-form-item>
            <span>时间:</span>
            <el-date-picker
              v-model="searchForm3.dateRange"
              type="daterange"
              range-separator="-"
              separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              style="width: 280px"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryClick3">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 数据表格 -->
      <el-table
        :data="tableData3"
        border
        stripe
        style="width: 100%; margin-top: 16px"
        class="custom-padding-table"
      >
        <el-table-column
          prop="code"
          label="产品ID"
          align="center"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="nickName"
          label="用户名(昵称)"
          align="center"
          min-width="260"
        ></el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="手机"
          align="center"
          min-width="260"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="分享时间"
          align="center"
          min-width="260"
        ></el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange3"
          @current-change="handleCurrentChange3"
          :current-page="pageInfo3.currentPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageInfo3.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total3"
        >
        </el-pagination>
      </div>
    </div>
    <div v-if="activeName == 'fourth'">
      <!-- 顶部搜索区域 -->
      <div class="search-box">
        <el-form :inline="true">
          <el-form-item>
            <span>时间:</span>
            <el-date-picker
              v-model="searchForm4.dateRange"
              type="daterange"
              range-separator="-"
              separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              style="width: 280px"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryClick4">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 数据表格 -->
      <el-table
        :data="tableData4"
        border
        stripe
        style="width: 100%; margin-top: 16px"
        class="custom-padding-table"
      >
        <el-table-column
          prop="code"
          label="产品编号"
          align="center"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="headline"
          label="产品标题"
          align="center"
          min-width="260"
        ></el-table-column>
        <el-table-column
          prop="nickName"
          label="用户名(昵称)"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="payTime"
          label="支付时间"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="amount"
          label="支付金额"
          align="center"
          min-width="120"
        ></el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange4"
          @current-change="handleCurrentChange4"
          :current-page="pageInfo4.currentPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageInfo4.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total4"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import util from "../../../util/date";
import { useEnterSearch, removeEnterSearch } from "../../../util/enterSearch";
import {
  getUserProductPopularityStatisticsListPageApi,
  getUserProductPopularityStatisticsCountApi,
  getProductShareLogListPage,
  getUserProductWatchDetailApi,
  getUserProductShoppingDetailApi,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  name: "ProductList",
  data() {
    return {
      buttonList: [],
      // 搜索表单
      searchForm: {
        productCodeOrTitle: "",
        status: "1",
      },
      searchForm2: {
        dateRange: "",
      },
      searchForm3: {
        dateRange: "",
      },
      searchForm4: {
        dateRange: "",
      },
      // 表格数据
      tableData: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],

      // 分页信息
      pageInfo: {
        currentPage: 1,
        pageSize: 20,
      },
      pageInfo2: {
        currentPage: 1,
        pageSize: 20,
      },
      pageInfo3: {
        currentPage: 1,
        pageSize: 20,
      },
      pageInfo4: {
        currentPage: 1,
        pageSize: 20,
      },
      total: 0, // 总条数，和截图一致
      total2: 0,
      total3: 0,
      total4: 0,

      statusOptions: [
        {
          value: "0",
          label: "未发布",
        },
        {
          value: "1",
          label: "已发布",
        },
        {
          value: "3",
          label: "已下架",
        },
        {
          value: "4",
          label: "维护中",
        },
      ],
      allCount: "",
      activeName: "first",
      code:null
    };
  },
  created() {
    // 初始化获取表格数据
    this.getTableList();
    this.getUserProductPopularityStatisticsCount();
  },
  mounted() {
    // 添加全局回车搜索功能
    useEnterSearch(() => {
      this.handleSearch();
    });
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
  beforeDestroy() {
    // 移除全局回车监听
    removeEnterSearch();
  },
  methods: {
     jumpDetail(val,type){
      console.log('val',val)
        this.code = val.code;
      console.log("type",type)
      if(type==1){
        this.activeName = 'second';
        this.pageInfo2.currentPage = 1;
        this.getUserProductWatchDetailFun();
      }else if(type==2){
        this.activeName = 'third';
        this.pageInfo3.currentPage = 1;
        this.getProductShareLogListPageFun();
      }else if(type==3 || type==4){
        this.activeName = 'fourth';
        this.pageInfo4.currentPage = 1;
        this.getUserProductShoppingDetailFun();
      }
       
    },
    getUserProductPopularityStatisticsCount() {
      getUserProductPopularityStatisticsCountApi().then((res) => {
        if (res.data.success) {
          this.allCount = res.data.response;
        }
      });
    },
    handleClick(val) {
      this.code = null;
      if (val.name == "first") {
        this.pageInfo.currentPage = 1;
        this.getTableList();
      } else if (val.name == "second") {
        this.pageInfo2.currentPage = 1;
        this.getUserProductWatchDetailFun();
      } else if (val.name == "third") {
        this.pageInfo3.currentPage = 1;
        this.getProductShareLogListPageFun();
      } else if (val.name == "fourth") {
        this.pageInfo4.currentPage = 1;
        this.getUserProductShoppingDetailFun();
      }
    },
    // 查询按钮
    handleSearch() {
      if (this.activeName == "first") {
        this.pageInfo.currentPage = 1;
        this.getTableList();
        this.$message.success("查询成功");
      } else if (this.activeName == "second") {
        this.pageInfo2.currentPage = 1;
        this.getUserProductWatchDetailFun();
        this.$message.success("查询成功");
      } else if (this.activeName == "third") {
        this.pageInfo3.currentPage = 1;
        this.getProductShareLogListPageFun();
        this.$message.success("查询成功");
      } else if (this.activeName == "fourth") {
        this.pageInfo4.currentPage = 1;
        this.getUserProductShoppingDetailFun();
        this.$message.success("查询成功");
      }
    },
    // apply改变this指向
    callFunction(item) {
      this[item.func].apply(this, item);
    },

    // 获取表格数据（模拟接口数据，和截图完全一致）
    getTableList() {
      let params = {
        ...this.searchForm,
        pageIndex: this.pageInfo.currentPage,
        pageSize: this.pageInfo.pageSize,
      };
      getUserProductPopularityStatisticsListPageApi(params).then((res) => {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      });
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableList();
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
      this.getTableList();
    },

    queryClick2() {
      this.pageInfo2.currentPage = 1;
      this.getUserProductWatchDetailFun();
    },
    getUserProductWatchDetailFun() {
      let params = {
        code:this.code,
        startTime: this.searchForm2.dateRange
          ? this.searchForm2.dateRange[0]
          : "",
        endTime: this.searchForm2.dateRange
          ? this.searchForm2.dateRange[1]
          : "",
        pageIndex: this.pageInfo2.currentPage,
        pageSize: this.pageInfo2.pageSize,
      };
      getUserProductWatchDetailApi(params).then((res) => {
        this.tableData2 = res.data.response.data;
        this.total2 = res.data.response.dataCount;
      });
    },
    // 每页条数改变
    handleSizeChange2(val) {
      this.pageInfo2.pageSize = val;
      this.getUserProductWatchDetailFun();
    },
    // 当前页改变
    handleCurrentChange2(val) {
      this.pageInfo2.currentPage = val;
      this.getUserProductWatchDetailFun();
    },

    queryClick3() {
      this.pageInfo3.currentPage = 1;
      this.getProductShareLogListPageFun();
    },
    getProductShareLogListPageFun() {
      this.tableData3 = []
      let params = {
        code:this.code,
        startTime: this.searchForm3.dateRange
          ? this.searchForm3.dateRange[0]
          : "",
        endTime: this.searchForm3.dateRange
          ? this.searchForm3.dateRange[1]
          : "",
        pageIndex: this.pageInfo3.currentPage,
        pageSize: this.pageInfo3.pageSize,
      };
      getProductShareLogListPage(params).then((res) => {
        this.tableData3 = res.data.response.data;
        this.total3 = res.data.response.dataCount;
      });
    },
    // 每页条数改变
    handleSizeChange3(val) {
      this.pageInfo3.pageSize = val;
      this.getProductShareLogListPageFun();
    },
    // 当前页改变
    handleCurrentChange3(val) {
      this.pageInfo3.currentPage = val;
      this.getProductShareLogListPageFun();
    },

    queryClick4() {
      this.pageInfo4.currentPage = 1;
      this.getUserProductShoppingDetailFun();
    },
    getUserProductShoppingDetailFun() {
      let params = {
        code:this.code,
        startTime: this.searchForm4.dateRange
          ? this.searchForm4.dateRange[0]
          : "",
        endTime: this.searchForm4.dateRange
          ? this.searchForm4.dateRange[1]
          : "",
        pageIndex: this.pageInfo4.currentPage,
        pageSize: this.pageInfo4.pageSize,
      };
      getUserProductShoppingDetailApi(params).then((res) => {
        this.tableData4 = res.data.response.data;
        this.total4 = res.data.response.dataCount;
      });
    },
    // 每页条数改变
    handleSizeChange4(val) {
      this.pageInfo4.pageSize = val;
      this.getUserProductShoppingDetailFun();
    },
    // 当前页改变
    handleCurrentChange4(val) {
      this.pageInfo4.currentPage = val;
      this.getUserProductShoppingDetailFun();
    },
  },
};
</script>

<style lang="stylus" scoped>
/* 页面容器 */
.product-container {
  padding: 20px;
  background: #fff;
  min-height: calc(100vh - 60px);
}

/* 搜索区域 */
.search-box {
  display: flex;
  gap: 10px;
}

.search-input {
  width: 380px;
}

.search-btn {
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
}

/* 分页区域 */
.pagination-box {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.total-count {
  color: #606266;
  font-size: 13px;
}

/* 表格样式统一 */
:deep(.el-table) {
  font-size: 13px;
}

:deep(.el-table__footer-wrapper) {
  font-weight: bold;
}

/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table {
  ::v-deep .el-table__cell {
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px;
    padding-bottom: 16px;
  }

  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
}

/* 👆👆👆 新增的样式结束 👆👆👆 */
</style>